import * as React from "react";
import * as ReactRedux from "react-redux";

import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";

import LogoWhite from "../components/LogoWhite";

import Register from "../components/login/register";


import {selectors as userSelectors, closeRegisterErrorModal} from "../reducers/current_user";
import Heading from "../components/Heading";
import WithCurrentUser from "../components/WithCurrentUser";

const mapStateToProps = state => ({
	registerErrorModalIsShowing: userSelectors.selectRegisterErrorModalIsShowing(state),
	registerErrorCode: userSelectors.selectRegisterErrorCode(state),
});

const mapDispatchToProps = {
	closeRegisterErrorModal,
};

interface RegisterPageProps {
	registerErrorModalIsShowing: boolean;
	registerErrorCode: string;
	closeRegisterErrorModal: () => any;
	isLoggedIn: string;
}

class RegisterPage extends React.Component<RegisterPageProps, any> {

	render() {

		return (
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
				}}
			>
				<Heading>Register</Heading>

				<p
					style={{
						marginTop: "1em",
					}}
				>

				</p>
				<Register/>

				<Dialog
					title="Error"
					actions={
						<>
							<FlatButton
								label="Ok"
								primary={true}
								keyboardFocused={true}
								onClick={this.props.closeRegisterErrorModal.bind(this)}
							/>
						</>
					}
					modal={false}
					open={this.props.registerErrorModalIsShowing}
					onRequestClose={this.props.closeRegisterErrorModal.bind(this)}
				>
					{this.props.registerErrorCode === ""
						? ""
						: this.props.registerErrorCode === "INVALID_EMAIL"
						? "You have entered an invalid email."
						: this.props.registerErrorCode === "TOKEN_UNAVAILABLE"
						? "An account already exists for the provided email."
						: "An unexpected error occurred."
					}
				</Dialog>
			</div>
		);
	}
}

const RegisterPageAfterRedux = ReactRedux.connect(
	mapStateToProps,
	mapDispatchToProps
)(RegisterPage);

export default (props: any) => (
	<WithCurrentUser>
		{(user, userFetchStatus, a, b, isLoggedIn) => (
			<RegisterPageAfterRedux isLoggedIn={isLoggedIn} {...props} />
		)}
	</WithCurrentUser>
);



// WEBPACK FOOTER //
// ./src/pages/register.tsx